// extracted by mini-css-extract-plugin
module.exports = {"bkg":"Loading_bkg__1T1j_","loadingif":"Loading_loadingif__l-nye","loading":"Loading_loading__1E18n"};